module.exports = __webpack_public_path__ + "img/5e8ed8975d07ef4b1c9f6c565143a280.png";